import React from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const AddOnsSelect = ({ addOns, value, onChange, error }) => {
    const handleAddOnSelect = (addOnId) => {
        if (addOnId) {
            const newSelectedValues = value.includes(String(addOnId))
                ? value
                : [...value, String(addOnId)];
            onChange({
                target: {
                    name: 'selectedAddOns',
                    value: newSelectedValues
                }
            });
        }
    };

    const handleRemoveAddOn = (addOnId) => {
        const newSelectedValues = value.filter(id => id != String(addOnId));
        onChange({
            target: {
                name: 'selectedAddOns',
                value: newSelectedValues
            }
        });
    };

    return (
        <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm={3}>
                Add-ons <span className='text-danger'>*</span>
            </Form.Label>
            <Col sm={9}>
                <Dropdown className="w-100 mb-2">
                    <Dropdown.Toggle
                        variant='light'
                        className={`form-select text-start ${styles.noCaret} w-100 ${error ? 'is-invalid' : ''}`}
                        id='add-on-select'
                    >
                        Select add-ons
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.dropdownMenu}>
                        <div className={styles.scrollableMenu}>
                            {addOns
                                .filter(addOn => !value.includes(String(addOn.id)))
                                .map((addOn) => (
                                    <Dropdown.Item
                                        key={addOn.id}
                                        onClick={() => handleAddOnSelect(addOn.id)}
                                    >
                                        {addOn.name}
                                    </Dropdown.Item>
                                ))}
                            {addOns.filter(addOn => !value.includes(String(addOn.id))).length === 0 && (
                                <div className={styles.noMatches}>No add-ons available</div>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>

                <div className={styles.themeChips}>
                    {value.map((addOnId) => {
                        const addOn = addOns.find(a => a.id == addOnId);
                        if (!addOn) return null;
                        return (
                            <span key={addOn.id} className={styles.themeChip}>
                                {addOn.name}
                                <button
                                    type="button"
                                    onClick={() => handleRemoveAddOn(addOn.id)}
                                    className={styles.removeChip}
                                >
                                    ×
                                </button>
                            </span>
                        );
                    })}
                </div>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </Col>
        </Form.Group>
    );
};

export default AddOnsSelect;
